import React, { createContext, useContext } from 'react';
import { SnackbarComponent } from './snackbar';
import {
  DEFAULT_ANCHOR_ORIGIN,
  DEFAULT_AUTO_HIDE_DURATION,
  SnackbarContextType,
  SnackbarProviderProps,
} from './types';
import { useSnackbar } from './useSnackbar';

const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined,
);

export const useSnackbarContext = (): SnackbarContextType => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error(
      'useSnackbarContext must be used within a SnackbarProvider',
    );
  }
  return context;
};

export const SnackbarProvider: React.FC<SnackbarProviderProps> = ({
  children,
  anchorOrigin = DEFAULT_ANCHOR_ORIGIN,
  autoHideDuration = DEFAULT_AUTO_HIDE_DURATION,
}) => {
  const { snackbars, showSnackbar, hideSnackbar, clearAll } = useSnackbar();

  const contextValue: SnackbarContextType = {
    showSnackbar: (message) => {
      showSnackbar({
        ...message,
        autoHideDuration: message.autoHideDuration ?? autoHideDuration,
      });
    },
    hideSnackbar,
    clearAll,
  };

  return (
    <SnackbarContext.Provider value={contextValue}>
      {children}
      {snackbars.length > 0 && (
        <SnackbarComponent
          key={snackbars[0].id}
          snackbar={snackbars[0]}
          onClose={hideSnackbar}
          anchorOrigin={snackbars[0].anchorOrigin ?? anchorOrigin}
        />
      )}
    </SnackbarContext.Provider>
  );
};
